module.exports = __webpack_public_path__ + "img/petrovich.16cb14be.svg";